import { invert } from 'lodash-es';
import { RAGE_CLICK_TYPE } from '../../../components/StatelessComponent/SingleFilter/RageClickFilter/RageClickFilterType';
import type {
  BooleanString,
  IntermediateFormat,
} from '../../../domains/global-filters/model/IntermediateFormat';
import type { QueryFormatFilter } from '../../../domains/global-filters/model/QueryFormat';
import { QueryKeyEnum } from '../../../domains/global-filters/model/QueryFormat';
import * as RadioConverter from './GenericConverter/RadioConverter';

const queryValueByUiValue: Record<RAGE_CLICK_TYPE, BooleanString> = {
  [RAGE_CLICK_TYPE.OCCURRED]: 'true',
  [RAGE_CLICK_TYPE.DID_NOT_OCCUR]: 'false',
};

const uiValueByQueryValue = invert(queryValueByUiValue) as Record<BooleanString, RAGE_CLICK_TYPE>;

export function fromUiToQueryFormat(uiValue: RAGE_CLICK_TYPE): QueryFormatFilter {
  return RadioConverter.fromUiToQueryFormat(uiValue, QueryKeyEnum.rageclick, queryValueByUiValue);
}

export function fromIntermediateToUiFormat(intermediateValue: IntermediateFormat): RAGE_CLICK_TYPE {
  return RadioConverter.fromIntermediateToUiFormat(intermediateValue, uiValueByQueryValue);
}
